import { render, staticRenderFns } from "./GiftCardTracePane.vue?vue&type=template&id=3696a9f9&scoped=true"
import script from "./GiftCardTracePane.vue?vue&type=script&lang=js"
export * from "./GiftCardTracePane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardTracePane.vue?vue&type=style&index=0&id=3696a9f9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696a9f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3696a9f9')) {
      api.createRecord('3696a9f9', component.options)
    } else {
      api.reload('3696a9f9', component.options)
    }
    module.hot.accept("./GiftCardTracePane.vue?vue&type=template&id=3696a9f9&scoped=true", function () {
      api.rerender('3696a9f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardTracePane.vue"
export default component.exports